import React from 'react';

export const AppFooter = (props) => {

    return (
        <div className="layout-footer">        
        </div>
    );
}
